
import axios from 'axios'

/**
 * Service to call welcome endpoints
 */
const EMRService = {
  /**
   * Get a single patient by ID
   * @param patientNo
   * @returns {*}
   */
  get (patientNo) {
    return new Promise((resolve, reject) => {
      axios
        .get(`fmceb/patients/${patientNo}`)
        .then(result => {
          resolve(result)
        })
        .catch(error => {
          if (error.response) {
            reject(error.response.data)
          } else {
            reject(new Error(error))
          }
        })
    })
  }
}

export default EMRService



// WEBPACK FOOTER //
// ./src/services/emr.service.js